import { useState } from 'react';
import dayjs, { Dayjs } from 'dayjs';

import { Option } from '../../../types/common.types';

import { OrderFilterInput } from '../graphQL/types';

interface Props {
  orderFilterInput: OrderFilterInput;
  handleSetOrderFilterInput: (key: string, value: any) => void;
}

function usePeriodFilter({
  orderFilterInput,
  handleSetOrderFilterInput,
}: Props) {
  const [isOpenDetailModal, setIsOpenDetailModal] = useState(false);
  const [selectedPeriod, setSelectedPeriod] = useState<Option>({
    label: '직접설정',
    value: 'custom',
  });

  const [dateValue, setDateValue] = useState({
    startedAt: null,
    endedAt: null,
  });

  // '상세조회' 모달 핸들러
  const handleDetailModal = () => {
    setIsOpenDetailModal(prev => !prev);
  };

  const handlePeriodButtonClick = (periodOpt: Option) => {
    setSelectedPeriod(periodOpt);

    if (periodOpt.value === 'custom') {
      setDateValue({
        startedAt: null,
        endedAt: null,
      });
    } else if (periodOpt.value === 'today') {
      const today = dayjs();
      setDateValue({
        startedAt: today,
        endedAt: today,
      });
    } else if (periodOpt.value === '1month') {
      const today = dayjs();
      const oneMonthAgo = today.subtract(1, 'month');
      setDateValue({
        startedAt: oneMonthAgo,
        endedAt: today,
      });
    } else if (periodOpt.value === '1year') {
      const today = dayjs();
      const oneYearAgo = today.subtract(1, 'year');
      setDateValue({
        startedAt: oneYearAgo,
        endedAt: today,
      });
    }
  };

  const handleDatePickerChange = (key: string, date: Dayjs) => {
    // setDateValue({
    //   startedAt: date,
    //   endedAt: date,
    // });

    setDateValue(prev => ({
      ...prev,
      [key]: date,
    }));
  };

  const initHandler = () => {
    setDateValue({
      startedAt: null,
      endedAt: null,
    });

    setSelectedPeriod({
      label: '직접설정',
      value: 'custom',
    });
  };

  const applyHandler = () => {
    if (dateValue.startedAt && dateValue.endedAt) {
      const startTime = dateValue.startedAt.valueOf();
      const endTime = dateValue.endedAt.valueOf();

      /* 오늘 날짜 선택시 */
      if (startTime === endTime) {
        const startOfDay = dateValue.startedAt.startOf('day').valueOf();
        const endOfDay = dateValue.endedAt.endOf('day').valueOf();

        handleUpdateSalePeriod(startOfDay, endOfDay);
        return handleDetailModal();
      }

      /* 시작 날짜가 종료 날짜보다 이전인 경우 */
      if (startTime <= endTime) {
        handleUpdateSalePeriod(startTime, endTime);
        return handleDetailModal();
      }

      window.alert('시작 날짜는 종료 날짜보다 이전이어야 합니다.');
      return;
    }

    initHandler();
    handleUpdateSalePeriod(null, null);
    return handleDetailModal();
  };

  // 검색 키워드 쿼리 업데이트
  const handleUpdateSalePeriod = (
    startedAt: number | null,
    endedAt?: number,
  ) => {
    // HackleManager.logSalesSearchComplete(
    //   selectedKeyword.label,
    //   selectedKeyword.value,
    //   '전체',
    //   // formatSalesTermType(filterValue.termType),
    // );

    if (startedAt) {
      const today = new Date();

      return handleSetOrderFilterInput('filter', {
        ...orderFilterInput.filter,
        // transactionTerm: termWithType,
        transactionTerm: {
          startedAt,
          endedAt: endedAt ? endedAt : today.getTime(),
        },
      });
    }

    handleSetOrderFilterInput('filter', {
      ...orderFilterInput.filter,
      transactionStatusIn: null,
      transactionTerm: null,
    });
  };

  return {
    // 상태
    isOpenDetailModal,
    selectedPeriod,
    dateValue,
    // 핸들러
    handleDetailModal,
    handlePeriodButtonClick,
    handleDatePickerChange,
    applyHandler,
    handleUpdateSalePeriod,
    // 초기화
    initHandler,
  };
}

export default usePeriodFilter;
